import { useTranslator } from '@gandi/translate';
export function getTheme(productType) {
  switch (productType) {
    case 'domain':
      return 'blue';
    case 'mailbox-standalone':
    case 'mailboxv2':
      return 'purple';
    case 'certificate':
      return 'green';
    case 'cloud':
      return 'red';
    case 'paas':
      return 'orange';
    case 'domain_option':
    case 'corporate':
    case 'marketplace':
    case 'tmch':
    default:
      return 'primary';
  }
}
export function useLabel(kind) {
  const {
    __
  } = useTranslator();
  switch (kind) {
    case 'DomainCreate':
      return __('Domain Registration');
    case 'services':
    case 'CorporateCreate':
      return __('Services');
    case 'DomainRenew':
      return __('Domain Renewal');
    case 'DomainRestore':
      return __('Domain Restore');
    case 'DomainTransfer':
      return __('Domain Transfer');
    case 'DomainChangeOwner':
      return __('Domain Owner Change');
    case 'CertificateCreate':
      return __('SSL Certificate Creation');
    case 'CloudAdd':
      return __('Cloud Resources');
    case 'PaasCreate':
      return __('Hosting Creation');
    case 'PaasRenew':
      return __('Hosting Renewal');
    case 'PaasUpdate':
      return __('Hosting Update');
    case 'MailboxCreate':
    case 'MailboxStandAloneCreate':
    case 'Mailboxv2Create':
      return __('Mailbox Creation');
    case 'MailboxUpdate':
    case 'Mailboxv2Update':
      return __('Mailbox Update');
    case 'MailboxRenew':
    case 'MailboxStandAloneRenew':
    case 'Mailboxv2Renew':
      return __('Mailbox Renew');
    case 'MailboxConvert':
    case 'Mailboxv2Convert':
      return __('Mailbox Conversion');
    case 'MarketplaceCreate':
      return __('Marketplace Service Creation');
    case 'MarketplaceRenew':
      return __('Marketplace Service Renewal');
    case 'MarketplaceUpdate':
      return __('Marketplace Service Update');
    case 'MarketplaceDelete':
      return __('Marketplace Service Deletion');
    case 'PremiumDNSCreate':
      return __('Domain Options');
    default:
      return __('Other products');
  }
}